import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export function canShowTrap(offer: IOfferSchema) {
  const { isResale, offerType, dealType } = offer;

  const isSaleFromSuburbanBuilder = dealType === 'sale' && offerType === 'suburban' && !isResale;

  return !isSaleFromSuburbanBuilder;
}
